module.exports = __webpack_public_path__ + "static/joomla-3-4eab3cc081e7cb4513331aa4cc875a39.png";